window.popup = ({ id, csrf_token }) => {
    return {
        timeout: null,
        init($dispatch) {
            this.timeout = setTimeout(() => {
                $dispatch('show-modal', { id });
            }, 2_000);
        },
        clearTimeouts(e) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }
        },
        onClose(e) {
            if (e.detail === id) {
                fetch('/popup-closed', {
                    method: 'POST',
                    cache: 'no-cache',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest',
                        'X-CSRF-Token': csrf_token,
                    },
                    body: JSON.stringify({
                        id,
                    }),
                });
            }
        },
    };
};
